// extracted by mini-css-extract-plugin
export default {"homePageProgramHead":"ProgramStats_homePageProgramHead__Bm1cO","grid-program-section":"ProgramStats_grid-program-section__8vzkS"};